const CookiePolicyPage = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Politika piškotkov</h1>

      <p>
        Bazarc uporablja piškotke za izboljšanje uporabniške izkušnje in za osnovno analitiko uporabe strani.
      </p>

      <h3 className="mt-4 mb-3">Kaj so piškotki?</h3>
      <p>
        Piškotki so majhne tekstovne datoteke, ki se shranijo na vašo napravo, ko obiščete našo spletno stran.
      </p>

      <h3 className="mt-4 mb-3">Katere piškotke uporabljamo?</h3>
      <p>
        Uporabljamo le nujne piškotke za delovanje platforme ter anonimne statistične piškotke (npr. Google Analytics).
      </p>

      <h3 className="mt-4 mb-3">Upravljanje piškotkov</h3>
      <p>
        Piškotke lahko kadarkoli izbrišete ali blokirate v nastavitvah vašega brskalnika.
      </p>
    </div>
  );
};

export default CookiePolicyPage;